const category = {
    categories: [],
    oldCategories: [],
    hasMore: true,
    isBusy: false,
    mode: 0, // 0 - create mode, 1 - edit mode
};

export default category;